/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SortDirection } from 'cio/utils/sort';

import CollectionModel from 'cio/models/collection';

interface CollectionsTableArgs {
  collections: CollectionModel[];
  sortBy: string;
  sortDirection: SortDirection;
  onSort: () => void;
  onImportRetry: () => unknown;
}

export default class CollectionsTable extends Component<CollectionsTableArgs> {
  columns = [
    {
      label: 'Name',
      value: 'name',
    },
    {
      label: 'Items',
      value: 'rows',
      class: 'grid-md-1',
    },
    {
      label: 'Last Updated',
      value: 'updatedAt',
      class: 'grid-md-2',
    },
  ];
}
